module.exports = __webpack_public_path__ + "img/ob_14.d680f201.jpg";